import { Hero } from "@/components/landing/Hero";
import { Types } from "@/components/landing/Types";
import { Work } from "@/components/landing/Work";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing, FinalCta } from "@/components/landing/Pricing";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Hero />
      <Types />
      <Work />
      <HowItWorks />
      <Pricing />
      <FinalCta />
    </div>
  );
}
